'use strict';

import NotificationBar from '../NotificationBar/NotificationBar';
import template from './templates/BomNotificationBar.hbs';

export default class BomNotificationBar extends NotificationBar {

  initialize() {
    this.template = template;
    super.initialize();
  }
}

export function createBomNotificationBar($parent) {
  if ($parent.length) {
    new BomNotificationBar({el: $parent})
  }
}



// WEBPACK FOOTER //
// ./assets/components/BomModal/BomNotificationBar.js